/**
  Automatically detects page builder forms and integrates them with the cart drawer developed by Rana
 */

document.addEventListener("DOMContentLoaded", function () {
  function isPageBuilderForm(element) {
    const hasInstantType = element.hasAttribute("data-instant-type");
    const hasInstantFormVariantId = element.hasAttribute("data-instant-form-variant-id");
    const hasInstantActionType = element.hasAttribute("data-instant-action-type");
    const hasInstantActionVariantId = element.hasAttribute("data-instant-action-variant-id");
    const hasInstantHref = element.hasAttribute("data-instant-href");
    const isRedirectToCart = element.getAttribute("data-instant-action-type") === "redirect-to-cart";
    const isThemeForm = element.hasAttribute("data-type") && element.getAttribute("data-type") === "add-to-cart-form";

    return (
      (hasInstantType || hasInstantFormVariantId || hasInstantActionType || hasInstantActionVariantId || hasInstantHref) &&
      isRedirectToCart &&
      !isThemeForm
    );
  }

  function handlePageBuilderButton(button) {
    const variantId = button.getAttribute("data-instant-form-variant-id") || button.getAttribute("data-instant-action-variant-id");

    if (!variantId) return;

    button.style.opacity = "0.6";
    button.style.pointerEvents = "none";

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        updateCartDrawer();
        button.style.opacity = "1";
        button.style.pointerEvents = "auto";
      })
      .catch((error) => {
        button.style.opacity = "1";
        button.style.pointerEvents = "auto";
        alert("Failed to add product to cart. Please try again.");
      });
  }

  function updateCartDrawer() {
    const cartDrawer = document.querySelector("cart-drawer");

    if (cartDrawer) {
      fetch("?sections=cart-drawer,cart-icon-bubble&sections_url=" + window.location.pathname)
        .then((response) => response.json())
        .then((sections) => {
          cartDrawer.renderContents({
            sections: sections,
          });
        })
        .catch((error) => {
          window.location.href = "/cart";
        });
    } else {
      window.location.href = "/cart";
    }
  }

  function setupButtonHandlers(button) {
    button.addEventListener(
      "click",
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        handlePageBuilderButton(button);
      },
      true
    );

    if (button.tagName === "FORM") {
      button.addEventListener(
        "submit",
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          handlePageBuilderButton(button);
        },
        true
      );
    }
  }

  function findPageBuilderForms() {
    const allForms = document.querySelectorAll("form");
    const pageBuilderForms = [];

    allForms.forEach(function (form) {
      if (isPageBuilderForm(form)) {
        pageBuilderForms.push(form);
      }
    });

    return pageBuilderForms;
  }

  const pageBuilderForms = findPageBuilderForms();

  pageBuilderForms.forEach(function (form) {
    setupButtonHandlers(form);
  });

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.tagName === "FORM" && isPageBuilderForm(node)) {
            setupButtonHandlers(node);
          }
          const childForms = node.querySelectorAll && node.querySelectorAll("form");
          if (childForms) {
            childForms.forEach(function (form) {
              if (isPageBuilderForm(form)) {
                setupButtonHandlers(form);
              }
            });
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  setTimeout(function () {
    const lateForms = findPageBuilderForms();
    lateForms.forEach(function (form) {
      if (!form.hasAttribute("data-page-builder-handled")) {
        setupButtonHandlers(form);
        form.setAttribute("data-page-builder-handled", "true");
      }
    });
  }, 2000);
});
